<template>
<div style="width: 85%; margin: auto; padding-top: 10px; color: #7b7c87">
    <v-layout row wrap>
      <v-flex
        xs12
        md12
        lg12
        xl12
        style="padding: 15px; padding-bottom: 2px !important"
      >
        <!--Row #1-->
        <v-layout row wrap>
          <v-flex
            xs12
            sm12
            md10
            lg10
            xl10
            style="padding: 15px; padding-bottom: 0px"
          >
            <div
              style="padding-top: 23px; font-weight: bolder; font-size: 20px"
            >
              {{PageTitle}}
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 sm12 md12 lg12 xl12 style="padding:20px">
          <v-card>
              <v-card-text>
                  <v-data-table :items="BoxTableItems" :headers="BoxTableHeaders">
                      <template v-slot:[`item.type`]="{item}">
                          <v-chip v-if="item.type == 2" color="blue" dark>لینک</v-chip>
                          <v-chip v-else-if="item.type == 1" color="orange" dark>محصول</v-chip>
                          <v-chip v-else-if="item.type == null" color="red darken-4" dark>تعریف نشده</v-chip>
                      </template>
                      <template v-slot:[`item.link`]="{item}">
                          <v-icon small v-if="item.type == 2" @click="window.open(`${item.link}`)" color="blue" dark>fa fa-eye</v-icon>
                          <span v-else-if="item.type == 1"  light>---</span>
                          <span v-else-if="item.type == null"  light>تعریف نشده</span>
                      </template>
                      <template v-slot:[`item.operation`]="{item}">
                          <v-btn color="yellow darken-4" icon @click="SetBoxDetail(item)"><v-icon small>fa fa-cog</v-icon></v-btn>&nbsp;
                          <v-tooltip v-if="item.type == 1" top color="purple darken-4">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                text
                                icon
                                v-bind="attrs"
                                v-on="on"
                                small
                                color="purple darken-4"
                                @click="ShowBoxProducts(item.sectionId)"
                                ><v-icon small>fas fa-compress-arrows-alt</v-icon></v-btn
                                >
                            </template>
                            <span>لیست محصولات</span>
                          </v-tooltip>
                      </template>
                  </v-data-table>
              </v-card-text>
          </v-card>
      </v-flex>
      <template>
          <v-dialog persistent fullscreen v-model="SetBoxDetailDialog">
              <v-card>
                <v-card-title style="padding: 0px !important">
                    <v-app-bar dense color="rgb(42, 45, 69)" dark>
                    <v-toolbar-title style="color: orange">
                        <span>تنظیمات باکس</span>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-icon color="orange" @click="SetBoxDetailDialog = false" small
                        >fa fa-times</v-icon
                    >
                    </v-app-bar>
                </v-card-title>
                <v-card-text>
                    <v-layout row wrap>
                        <v-flex xs12 sm12 md4 lg4 xl4 style="padding:20px">
                            <v-row v-if="Type != 7">
                                <v-col cols="8"><span v-if="!boxType">لیست محصول</span><span v-else>لینک</span> :</v-col>
                                <v-col cols="4" style="display: flex; justify-content: flex-end">
                                    <v-switch v-model="boxType"  style="padding-top: 0px !important;margin-top: 0px !important;" color="#2a2d45"></v-switch>
                                </v-col>
                            </v-row>
                            <v-text-field
                            color="#2a2d45"
                            v-model="boxTitle"
                            outlined
                            dense
                            label="عنوان باکس "
                            ></v-text-field>
                            <v-text-field
                            v-if="boxType"
                            color="#2a2d45"
                            v-model="boxLink"
                            outlined
                            dense
                            label="لینک "
                            ></v-text-field>
                            <v-row>
                              <v-col cols="8">وضعیت :</v-col>
                              <v-col cols="4" style="display: flex; justify-content: flex-end">
                                <v-switch v-model="boxStatus" style="padding-top: 0px !important;margin-top: 0px !important;" color="#2a2d45"></v-switch>
                              </v-col>
                            </v-row>
                            <f-up  :OldFile="boxImage" @RetunedFileName="boxImage = $event" Root="ELOGO" Folder="NONE" BtnTitle="عکس"></f-up>
                            <v-btn @click="SaveBoxDetail" outlined dark color="blue">
                              <v-icon small style="padding-left: 5px"
                                >fa fa-check</v-icon
                              >&nbsp; ذخیره
                            </v-btn>
                        </v-flex>
                        <v-flex xs12 sm12 md8 lg8 xl8 style="padding:20px">
                            <seo-form FileLoc="PRDCATSEOIMG" :Seo="SeoData" @SeoData="SeoChanged" v-if="!boxType"></seo-form>
                        </v-flex>
                    </v-layout>
                </v-card-text>
              </v-card>
          </v-dialog>
      </template>
      <template>
        <v-dialog fullscreen persistent v-model="SetBoxProductsDialog">
         <v-card>
         <v-card-title style="padding: 0px !important">
            <v-app-bar dense color="rgb(42, 45, 69)" dark>
              <v-toolbar-title style="color: orange">
                <span>محصولات باکس</span>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-icon color="orange" @click="SetBoxProductsDialog = false" small
                >fa fa-times</v-icon
              >
            </v-app-bar>
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 sm12 md4 lg4 xl4 style="padding:20px">
                <v-text-field outlined v-model="SetProductsSearchByPName" dense label="نام محصول"></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md4 lg4 xl4 style="padding:20px">
                <v-text-field outlined dense v-model="SetProductsSearchByPCode" label="کد محصول"></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md4 lg4 xl4 style="padding:20px">
                <v-btn @click="loadProductsForSet(1)" outlined block color="rgb(42, 45, 69)"><v-icon small style="padding-left:5px">fa fa-search</v-icon>جستجو</v-btn>
              </v-flex>
              <v-flex xs12 sm12 md12 lg12 xl12 style="padding:20px">
                <div class="d-flex justify-center align-center cpation font-weight-black">همه محصولات</div>
              </v-flex>
              <v-flex xs12 sm12 md12 lg12 xl12 style="padding:20px">
                <v-data-table :items="SetAllProductTableItems" hide-default-footer :headers="MainTableHeader">
                  <template v-slot:[`item.operation`]="{item}">
                    <v-btn x-small @click="ShiftToSetTabl(item)" color="green accent-4"><v-icon color="#fff" x-small>fa fa-plus</v-icon></v-btn>
                  </template>
                </v-data-table>
                <v-row>
                  <v-col cols="10"><v-pagination @input="SetProdTableJumpToPage($event)" v-model="CurrentPageSet" color="orange" :length="PageCountsSet" total-visible></v-pagination></v-col>
                  <v-col cols="2"><v-select @change="loadProductsForSet(1)" label="تعداد آیتم در صفحه" :items="PageSizeItems" item-text="text" item-value="value" outlined dense v-model="PageSizeSet"></v-select></v-col>
                </v-row>
              </v-flex>
              <v-flex xs12 sm12 md12 lg12 xl12 style="padding:20px" class="flex-row d-flex justify-sm-space-between">
                <div class="d-flex justify-center align-center cpation font-weight-black">محصولات زیر مجموعه</div>
                <v-btn outlined color="green" @click="SaveProductSet()"><v-icon small style="padding-left:5px">fa fa-check</v-icon>بروزرسانی</v-btn>
              </v-flex>
              <v-flex xs12 sm12 md12 lg12 xl12 style="padding:20px">
                <v-data-table :items="SetTableItems" :headers="RelationTableHeader">
                  <template v-slot:[`item.operation`]="{item}">
                    <v-btn x-small @click="DeleteFromSetTable(item)" color="red accent-4"><v-icon color="#fff" x-small>fa fa-trash</v-icon></v-btn>
                  </template>
                  <template v-slot:[`item.discountype`]="{item}">
                      <v-row>
                          <v-col cols="4" style="display: flex;justify-content: flex-end;">
                              <v-switch :label="(item.discountype) ? 'ریال':'درصد'" v-model="item.discountype" style="padding-top:0px !important;margin-top:0px !important" color="#2a2d45"></v-switch>
                          </v-col>
                     </v-row>

                  </template>
                  <template v-slot:[`item.discount`]="{item}">
                    <v-row>
                      <v-col cols="2"><v-btn @mouseleave="stop" @mouseup="stop" @touchend="stop" @touchcancel="stop" @mousedown="start(item)" @touchstart="start(item)" small icon><v-icon small>fa fa-plus</v-icon></v-btn></v-col>
                      <v-col cols="8">
                        <v-text-field flat full-width style="text-align:center;justify-content:center" v-model="item.discount" outlined dense></v-text-field>
                      </v-col>
                      <v-col cols="2"><v-btn @click="(item.discount > 0)? item.discount--:item.discount = 0" small icon><v-icon small>fa fa-minus</v-icon></v-btn></v-col>
                    </v-row>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
            
          </v-card-text>
        </v-card>

        </v-dialog>
      </template>
              <template><!--Loading Dialog-->
            <div class="vld-parent">
                <loading color="#f75314" :width="parseInt(45)" :height="parseInt(45)" background-color="#fff" :active.sync="isLoading" 
                :is-full-page="true"></loading>
                
               
            </div>
        </template>
    </v-layout>
</div>

</template>
<script>
const axios = require("axios");
const ApiUrl = require("../../constant/apiurl");
const MSGHNDL = require("../../constant/MessageHandler");
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import JsonExcel from "vue-json-excel";

export default {
    props:["EntityId","Type"],
    name:"PromotionBoxs",
    components: {
    Loading,
    JsonExcel,
  },
    data:()=>({
    DisableTypeSwitch : true,
    isLoading:false,
    SetProductDialog:false,
    SetProductsSearchByPName:"",
    SetProductsSearchByPCode:"",
    SetAllProductTableItems:[],
    SetTableItems:[],
    CurrentPageSet : 0,
    PageCountsSet: 0 ,
    PageSizeSet: 5,
    PageSizeItems:[
      {text:"5",value:5},
      {text:"10",value:10},
      {text:"20",value:20},
      {text:"40",value:40},
      {text:"100",value:100},
      {text:"200",value:200},
      {text:"500",value:500},
      {text:"1000",value:1000}
    ],
    RelationTableHeader: [
      { text: "#", value: "counter", sortable: true, align: "right" },
      { text: "کد", value: "code", sortable: true, align: "right" },
      { text: "محصول ", value: "title", sortable: true, align: "right" },
      { text: "گارانتی ", value: "warranty", sortable: true, align: "right" },
      { text: "رنگ ", value: "color", sortable: true, align: "right" },
      { text: "قیمت ", value: "price", sortable: true, align: "right" },
      { text: "تخفیف ", value: "discount", sortable: true, align: "right" },
      { text: "نوع تخفیف ", value: "discountype", sortable: true, align: "right" },
      { text: "عملیات ", value: "operation", sortable: true, align: "right" },
    ],
    MainTableHeader: [
      { text: "#", value: "counter", sortable: true, align: "right" },
      { text: "کد", value: "code", sortable: true, align: "right" },
      { text: "محصول ", value: "title", sortable: true, align: "right" },
      { text: "گارانتی ", value: "warranty", sortable: true, align: "right" },
      { text: "رنگ ", value: "color", sortable: true, align: "right" },
      { text: "قیمت ", value: "price", sortable: true, align: "right" },
      { text: "تخفیف ", value: "discount", sortable: true, align: "right" },
      { text: "عملیات ", value: "operation", sortable: true, align: "right" },
    ],
    BoxTableHeaders:[
        { text: "#", value: "counter", sortable: true, align: "right" },
        { text: "عنوان باکس", value: "title", sortable: true, align: "right" },
        { text: "نوع باکس", value: "type", sortable: true, align: "right" },
        { text: "لینک", value: "link", sortable: true, align: "right" },
        { text: "عملیات", value: "operation", sortable: true, align: "right" },
    ],
    BoxTableItems:[
    ],
    SetBoxDetailDialog:false,
    boxId:"",
    boxTitle:"",
    boxType:false,
    boxLink:"",
    boxImage:"",
    uploadBoxImage:"",
    SeoData:{},
    seo:{},
    SetBoxProductsDialog:false,
    SetProductBoxId:0,
    SetProductsSearchByPName:"",
    SetProductsSearchByPCode:"",
    SetAllProductTableItems:[],
    interval:false,
    SelectedItem:{},
    boxStatus:true
    }),
    async created(){
        let vm = this;
        await vm.Initil();
        vm.boxType = (vm.Type == 7) ? true  : false;
    },
    mounted(){
        this.Initil();
    },
    methods:{
        async Initil()
        {
            let vm = this;
             switch(vm.Type)
                {
                    case 3://Category Discounted Boxs
                        vm.BoxTableItems = [
                            {counter:1,title:"باکس 1",type:null,link:"",image:"",seo:"",sectionId:25},
                            {counter:2,title:"باکس 2",type:null,link:"",image:"",seo:"",sectionId:26},
                            {counter:3,title:"باکس 3",type:null,link:"",image:"",seo:"",sectionId:27},
                            {counter:4,title:"باکس 4",type:null,link:"",image:"",seo:"",sectionId:28},
                            {counter:5,title:"باکس 5",type:null,link:"",image:"",seo:"",sectionId:29},
                            ]
                            vm.PageTitle = "باکس های تخفیفی";
 
                            
                        break;
                    case 4://Category Side Bar Ads
                        vm.BoxTableItems = [
                            {counter:1,title:"باکس 1",type:null,link:"",image:"",seo:"",sectionId:30},
                            ]
                            vm.PageTitle = "باکس های تبلیغاتی کناری";

                        break;
                    case 5://Category Moveable Ads
                        vm.BoxTableItems = [
                            {counter:1,title:"باکس 1",type:null,link:"",image:"",seo:"",sectionId:31},
                            {counter:2,title:"باکس 2",type:null,link:"",image:"",seo:"",sectionId:32}
                            ]
                            vm.PageTitle = "باکس های تبلیغاتی متحرک";
                            
                        break;
                      case 7://Category Discounted Boxs
                        vm.BoxTableItems = [
                            {counter:1,title:"باکس 1",type:2,link:"",image:"",seo:"",sectionId:36},
                            {counter:2,title:"باکس 2",type:2,link:"",image:"",seo:"",sectionId:37},
                            // {counter:3,title:"باکس 3",type:2,link:"",image:"",seo:"",sectionId:38},
                            // {counter:4,title:"باکس 4",type:2,link:"",image:"",seo:"",sectionId:39},
                            // {counter:5,title:"باکس 5",type:2,link:"",image:"",seo:"",sectionId:40},
                            ]
                            vm.PageTitle = "باکس های لینک دار";
 
                            
                        break;
                }
                    vm.uploadBoxImage = ApiUrl.registerPcImg;
                    await vm.LoadBoxs();
                    await vm.loadProductsForSet();


        },
     async SaveProductSet() {
      let vm = this;
      if (vm.SetTableItems.length > 0) {
        let ArrObject = [];
        
        
        vm.SetTableItems.forEach((e) => {
          var Model = {};
          Model.X_SectionId = vm.SetProductBoxId;
          Model.X_ProdId = e.id;
          Model.X_ColorId = e.cid;
          Model.X_WarrantyId = e.wid;
          Model.X_DiscountedPrice = e.discount;
          Model.X_DiscountType = e.discountype;
          ArrObject.push(Model);
        });
        await axios
          .post(ApiUrl.AddProductToBox, ArrObject)
          .then(async (res) => {
            let data = res.data;
            if (data.status) {
              MSGHNDL.OK(data.msg);
              await vm.loadProductsForSet();
            }
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },

    stop(){
    	clearInterval(this.interval)
      this.interval = false
    },
    start(item){
      this.SelectedItem = item;
    	if(!this.interval){
      	this.interval = setInterval(() => this.SelectedItem.discount++, 30)	
      }
    },
    ShiftToSetTabl(item)
    {
      let vm = this;
      if(vm.SetTableItems.some(x=>x.id == item.id && x.wid == item.wid && x.cid == item.cid))
      {
        MSGHNDL.ERR("تنوع مورد نظر قبلا اضافه شده است");
      }
      else
      {
        vm.SetTableItems.push(item);
      }
    },

      async ShowBoxProducts(bid)
      {
        let vm = this;
        vm.SetBoxProductsDialog = true;
        vm.SetProductBoxId = bid;
        await vm.LoadSets();
      },
      async LoadBoxs()
      {
        let vm = this;
        await axios.post(ApiUrl.LoadPromotionBox+'/'+vm.Type).then((res)=>{
          var data = res.data;
          if(data.status)
          {
            for(var i in vm.BoxTableItems)
            {
              var find = data.data.findIndex(_item => _item.b_SectionId === vm.BoxTableItems[i].sectionId);
              if(find != -1)
              {
                var ritem = data.data[find];
                var litem = vm.BoxTableItems[i];
                console.warn(ritem.b_LoadType );
                litem.title = ritem.b_Title;
                litem.type = ritem.b_LoadType ;
                litem.link = ritem.b_Link;
                litem.image = ritem.b_Image;
                litem.status = ritem.b_Status;
                litem.seo = ritem.b_Seo;
              }
            }
          }
        }).catch((err)=>{
          console.error("ERROR IN LOADING BOX INFORMATION",err);
        });
      },
      async SaveBoxDetail()
      {
        var vm = this;
        var Model = {};
        Model.B_Title = vm.boxTitle;
        Model.B_Image = vm.boxImage;
        Model.B_Seo = JSON.stringify(vm.seo);
        Model.B_Link = vm.boxLink;
        Model.B_SectionId = vm.boxId;
        Model.B_LoadType = vm.boxType ? 2:1;
        Model.B_Type = vm.Type;
        Model.B_EntityId = vm.EntityId;
        Model.B_Status = vm.boxStatus;
        await axios.post(ApiUrl.AddPromotionBox,Model).then(async (res)=>{
          var data = res.data;
          if(data.status)
          {
            MSGHNDL.OK(data.msg);
            await vm.LoadBoxs();
            vm.SetBoxDetailDialog = false;
          }
          else
          {
            MSGHNDL.ERR(data.msg);
          }

        }).catch((err)=>{console.error(err)});

      },
      SeoChanged(seo)
      {
        this.seo = seo;
      },
    SetBoxDetail(secid)
    {
        this.boxId = secid.sectionId;
        if(secid.type != null)
        {
          this.boxType = secid.type == 1 ? false:true;
        }
        else
        {
          this.boxType = false;
        }
        
        this.boxTitle = secid.title;
        this.boxLink = secid.link;
        this.boxStatus = secid.status;
        this.boxImage = secid.image;
        this.SeoData = secid.seo == "" ? {} : JSON.parse(secid.seo);
        this.SetBoxDetailDialog = true;
    }, 
    async SetProdTableJumpToPage(page)
    {
      await this.loadProductsForSet(page);
    },
    async loadProductsForSet(page = 1) {
      let vm = this;
      var url = ApiUrl.LoadProductForBoxs +"/0/"+page+"/"+vm.PageSizeSet;
      if(vm.SetProductsSearchByPName != null && vm.SetProductsSearchByPName != "")
      {
        url+="/"+vm.SetProductsSearchByPName;
      }
      if(vm.SetProductsSearchByPCode != null && vm.SetProductsSearchByPCode != "")
      {
        url+="/"+vm.SetProductsSearchByPCode;
      }
      await axios
        .post(
          url
        )
        .then(async (res) => {

          let data = res.data;
          console.warn(data);
          if (data.status) {
            vm.SetAllProductTableItems = data.data.products;
            vm.PageCountsSet = data.data.totalPages;
            vm.CurrentPageSet = data.data.currentPage;
            vm.RelationDataLoaded = true;
            console.warn("LOADING RELATION DATA",data.data);
             await vm.LoadSets();
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    async LoadSets()
    {
      let vm = this;
      var Model = {};
      Model.Id = vm.SetProductBoxId;
      await axios.post(ApiUrl.LoadPromotionBoxProds,Model)
      .then(res=>{
        let data = res.data;
        if(data.status)
        {
          console.warn("RELATIONSSSSSSSSSSSSSSSSS:",data.data);
          if(data.data.length > 0)
          {
            vm.SetTableItems = [];
            
            data.data.forEach(el => {
              var item = vm.SetAllProductTableItems.findIndex(i=>i.id == el.x_ProdId && i.wid == el.x_WarrantyId && i.cid == el.x_ColorId);
              var element = vm.SetAllProductTableItems[item];
              element.discount = el.x_DiscountedPrice;
              element.discountype = el.x_DiscountType;
              vm.SetTableItems.push(element);
            });
          }
        }
        else
        {
         MSGHNDL.ERR(data.msg);
        }
      })
      .catch(err=>{console.error(err);});
    },

    }
}
</script>